import { render } from "./index.vue?vue&type=template&id=78f7302b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=78f7302b&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f7302b"],['__file',"src/views/settings/wePay/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78f7302b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78f7302b', __exports__)) {
    console.log('reload')
    api.reload('78f7302b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=78f7302b&scoped=true", () => {
    console.log('re-render')
    api.rerender('78f7302b', render)
  })

}


export default __exports__